import React, { useState } from "react";
import api from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "../style/passbook.css";
import CustomerSearch from "./CustomerSearch";
import { FaEye } from "react-icons/fa";

const Passbook = () => {
  const navigate = useNavigate();
  const [selectedCustomer, setSelectedCustomer] = useState();

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });

  const [passbookList, setPassbookList] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH PASSBOOK SUMMARY ---------------- */
  const fetchPassbookSummary = async () => {
    // 🔥 VERY IMPORTANT CHECK
    if (!selectedCustomer) {
      alert("Please select a customer first");
      return;
    }
    try {
      
      setLoading(true);

      const token = localStorage.getItem("token");
     
       console.log("JWT token:", `Bearer ${token}`);
       console.log("Making request to:", "challans/passbook");
       console.log("Request params:", {
          name: selectedCustomer.name,
          fromDate: filters.fromDate || null,
          toDate: filters.toDate || null,
          page: 0,
          size: 10
        });

      const response = await api.get(
        "challans/passbook",
        {
          params: {
            name: selectedCustomer.name,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            page: 0,
            size: 10
          },
        }
      );

       console.log("API Response:", response);
       console.log("Response status:", response.status);
       console.log("Response data:", response.data);
       console.log("Response content:", response.data?.content);
       console.log("Content length:", response.data?.content?.length);
       console.log("Setting passbookList to:", response.data?.content || response.data || []);

      setPassbookList(response.data?.content || response.data || []);
       console.log("PassbookList after set:", response.data?.content || response.data || []);
    } catch (error) {
      console.error("Error fetching passbook summary:", error);
      console.error("Error details:", error.response);
      alert("Failed to load passbook data");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- HANDLE FILTER CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  /* ---------------- RESET FILTERS ---------------- */
  const handleReset = () => {
    setFilters({
      fromDate: "",
      toDate: "",
    });

    // Only clear customer selection, don't clear the passbook data
    setSelectedCustomer(null);   
    // setPassbookList([]);
  };

  /* ---------------- HANDLE VIEW PASSBOOK ---------------- */
  const handleViewPassbook = (product) => {
    // Navigate to detailed view with customer and product info
    navigate('/dashboard/ViewPassbook', {
      state: {
        customerId: selectedCustomer?.id,
        customerName: selectedCustomer?.name,
        productName: product.name,
        productId: product.id
      }
    });
  };

  return (
    <div className="pb-container">
      <div className="pb-card">
        {/* Header */}
        <div className="pb-header">
          <div className="pb-header-left">
            <div className="pb-icon">📖</div>
            <h2>Passbook</h2>
          </div>
        </div>

        {/* Form Section */}
        <div className="pb-grid">
          <div className="pb-field">
            <label></label>
            <CustomerSearch onSelectCustomer={setSelectedCustomer} />
          </div>

          <div className="pb-field">
            <label>From Date</label>
            <input
              type="date"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleChange}
            />
          </div>

          <div className="pb-field">
            <label>To Date</label>
            <input
              type="date"
              name="toDate"
              value={filters.toDate}
              onChange={handleChange}
            />
          </div>

          <div className="pb-field pb-field-actions">
            <label>&nbsp;</label>
            <div className="pb-button-group">
              <button className="pb-btn-outline pb-btn-responsive" onClick={handleReset}>
                Clear
              </button>
              <button className="pb-btn-primary pb-btn-responsive" onClick={fetchPassbookSummary}>
                Apply Filter
              </button>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="pb-table-section">
          <h3>Transaction History</h3>
          <div className="pb-table-info">
            <p>Showing {passbookList.length} challan records</p>
          </div>
          
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Loading passbook data...</p>
            </div>
          ) : (
            <div className="table-wrapper responsive-table-container">
              <table className="passbook-table responsive-table">
                <thead>
                  <tr>
                    <th className="col-date">Date</th>
                    <th className="col-challan">Challan No</th>
                    <th className="col-type">Type</th>
                    <th className="col-product">Product</th>
                    <th className="col-qty">Quantity</th>
                    <th className="col-location">Location</th>
                    <th className="col-amount">Amount</th>
                    <th className="col-actions">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {passbookList.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="no-data">
                        <div className="no-data-icon">📋</div>
                        <p>No transactions found</p>
                      </td>
                    </tr>
                  ) : (
                    passbookList.map((challan) => (
                      <tr key={challan.id}>
                        <td className="col-date">
                          <div className="date-value">
                            {new Date(challan.date).toLocaleDateString('en-IN', { 
                              day: '2-digit', 
                              month: '2-digit', 
                              year: 'numeric' 
                            })}
                          </div>
                        </td>
                        <td className="col-challan">
                          <div className="challan-number">{challan.challanNumber}</div>
                        </td>
                        <td className="col-type">
                          <span className={`type-badge ${challan.challanType ? challan.challanType.toLowerCase() : ''}`}>
                            {challan.challanType || 'N/A'}
                          </span>
                        </td>
                        <td className="col-product">
                          {challan.items?.map(item => item.name).join(', ') || 'N/A'}
                        </td>
                        <td className="col-qty">
                          {challan.items?.reduce((sum, item) => sum + (item.deliveredQty || item.receivedQty || 0), 0)}
                        </td>
                        <td className="col-location">
                          {challan.siteLocation || 'N/A'}
                        </td>
                        <td className="col-amount">
                          <div className="amount-value">
                            ₹{Number(challan.returnedAmount || 0).toLocaleString('en-IN')}
                          </div>
                        </td>
                        <td className="col-actions">
                          <button 
                            className="btn btn-outline-primary btn-sm" 
                            onClick={() => handleViewPassbook(challan)}
                            title="View detailed challan"
                          >
                            <FaEye /> View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Passbook;
